export const reviewsList = {
  PARTY_COMPOSITION_FILTER: 'reviewsList.partyCompositionFilter',
  SORTING_FILTER: 'reviewsList.sortingFilter'
}
